import { useMutation } from 'react-query';

import { bulkAssignTagsToCards as mutationFn } from 'api/endPoints/bulkAssignTagsToCards';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationBulkTags = () => {
    return useMutation<string, QueryError, IBulkTagsPayload>((params) => mutationFn(params));
};

interface IBulkTagsPayload {
    bulkAssigneeToTagsUniqIdNotification: number;
    tagToBulkAssignList: {
        name: string;
    }[];
    filter: {
        filters: IFilter;
    };
    paging: {
        page: number;
        size: number;
    };
    withDetails: boolean;
}
